export default __webpack_public_path__ + "static/media/Platinum.5a767a55.svg";